import React from 'react';

import { useQuery } from '@tanstack/react-query';
import ContentLoader from 'react-content-loader';
import { useParams } from 'react-router-dom';

import BackButton from '../../../components/common/buttons/BackButton';
import CourseAvailableTimes from '../../../components/common/library/course/CourseAvailableTimes';
import CourseDetails from '../../../components/common/library/course/CourseDetails';
import CourseOutline from '../../../components/common/library/course/CourseOutline';
import CourseReviews from '../../../components/common/library/course/CourseReviews';
import NavHeader from '../../../components/common/NavHeader';
import { NAVIGATE_PATH } from '../../../helpers/constants';
import { getPublicCourse } from '../../../requests';
import NotFound from '../../NotFound';

const PublicCourse: React.FC = () => {
  const { slug } = useParams();

  const { data: course, isLoading } = useQuery({
    queryKey: ['publicCourse', slug],
    queryFn: () => getPublicCourse(slug),
  });

  return (
    <>
      <NavHeader
        label={
          <BackButton
            defaultRoute={NAVIGATE_PATH.publicCourses}
            usePrevious={true}
          />
        }
      />
      {isLoading ? (
        <div className="h-screen pt-8 bg-white main-container">
          <div className="w-full guest-wrapper guest:mx-auto">
            <ContentLoader className="w-full xl:w-[70%] h-96">
              <rect x="0" y="0" rx="10" ry="10" width="100" height="100" />
              <rect x="0" y="116" rx="5" ry="5" width="300" height="56" />
              <rect x="0" y="188" rx="5" ry="5" width="100%" height="150" />
            </ContentLoader>
          </div>
        </div>
      ) : course ? (
        <div className="min-h-[calc(100vh-114px)] xl:min-h-[calc(100vh-60px)] flex flex-col bg-grey-50">
          <div className="px-4 pt-8 pb-10 bg-white lg:px-8">
            <div className="flex flex-col w-full gap-6 mx-auto guest:guest-wrapper 2xl:flex-row lg:guest:flex-row">
              <div className="flex grow">
                <CourseDetails course={course} />
              </div>
              <div className="lg:min-w-[35%]">
                <CourseAvailableTimes course={course} />
              </div>
            </div>
          </div>
          <CourseOutline course={course} />
          <CourseReviews reviews={course.reviews} />
        </div>
      ) : (
        <NotFound />
      )}
    </>
  );
};

export default PublicCourse;
